import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, takeUntil, tap } from 'rxjs/operators';

import { SmartSmsCampaignsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import {
  CustomResultOfPaginatedListOfSmartSmsCampaignsWithPaginationDto,
  GetEnumValuesDto,
  PaginatedListOfSmartSmsCampaignsWithPaginationDto,
  SmartSmsCampaignsWithPaginationDto,
} from '../../../../app/core/api/models';
import { AppDomService } from '../../../core/services/dom.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { SmartSmsCampaignsFormComponent } from './smart-sms-campaigns-form/smart-sms-campaigns-form.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { CampaignStatusInGatewayComponent } from './campaign-status-in-gateway/campaign-status-in-gateway.component';


@Component({
    selector: 'app-smart-sms-campaigns',
    styleUrls: ['./smart-sms-campaigns.component.scss'],
    templateUrl: './smart-sms-campaigns.component.html',
    imports: [
        BaseIndexModule,
        CampaignStatusInGatewayComponent,
    ]
})
export class SmartSmsCampaignsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = 'smartSmsCampaigns';
  protected currentService = inject(SmartSmsCampaignsService);
  paginationApiMethodName: string = this.currentService.smartSmsCampaignsGetSmartSmsCampaignsWithPagination.name;
  createGetApiMethodName: string = this.currentService.smartSmsCampaignsCreateGet.name;
  modelWithPagination$: Observable<PaginatedListOfSmartSmsCampaignsWithPaginationDto>;
  items$: Observable<Array<SmartSmsCampaignsWithPaginationDto>>;
  formPageConfig: FormPageConfig<SmartSmsCampaignsWithPaginationDto> = {};
  isShowCampaignStatusInGateway: boolean = false;
  campaignId: any;
  CreationLocationEnumValues: GetEnumValuesDto[] = [];
  campaignTitle: any;

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAuditBtn = false;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('EntityCreationLocation')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.CreationLocationEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.id, name: 'id', hasSearch: true },
      { title: this.localizer.name, name: 'title', hasSearch: true },
      {
        title: 'common.creationLocation',
        name: 'creationLocation',
        hasSearch: true,
        type: 'enum',
        enumName: 'EntityCreationLocation',
        wrap: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Delete
  // baseDeleteApi(id: number) {

  //   this.unSubs();

  //   this.pageConfig.loading = true;
  //   this.lastSelectedItemId = id;

  //   this.currentService.smartSmsCampaignsDelete({ body: { id: id } })
  //     .pipe(this.basePipeOperators())
  //     .subscribe(this.baseDeleteObserver);

  // }

  deleteSmartSmsCampaignApi(ids: number[]) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = ids;

    this.currentService
      .smartSmsCampaignsDelete({ body: { ids: ids } })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.selectedIds = []))
      )
      .subscribe(this.baseGroupDeleteObserver);
  }

  //#endregion

  //#region call Actions

  openCreateFormModal() {
    try {
      this.unSubs();

      let data = {
        title: `${this.formPageConfig?.vocabs}addTitle`,
        isEdit: false,
      };

      const modalResult = this.dialogService.openModal({
        component: SmartSmsCampaignsFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          finalize(() => (this.pageConfig.isVisibleForm = undefined)),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#endregion

  //#region group Deletion
  callGroupDeletion() {
    this.deleteSmartSmsCampaignApi(this.selectedIds);
  }

  //#endregion

  onDelete(id: any, content: any, confirmByWritingText?: boolean) {
    const dialogResult = this.getConfirmDialog({
      content: content,
      isConfirmDelete: true,
      confirmByWritingText: confirmByWritingText,
    });

    dialogResult
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result) {
          this.pageConfig.loading = true;
          this.selectedIds = [];
          this.selectedIds.push(id);
          this.deleteSmartSmsCampaignApi(this.selectedIds);
        }
      });
  }

  onCampaignStatusInGateway(id, title) {
    this.showParent = false;
    this.setParentQueryString();

    this.campaignId = id;
    this.campaignTitle = title;
    this.isShowCampaignStatusInGateway = true;
  }

  onHideCampaignStatusInGateway() {
    this.showParent = true;
    this.getParentQueryString();

    this.isShowCampaignStatusInGateway = false;
  }
}
